
export interface FatigueAssessmentQuestion {
    key: string,
    value: string,
    altValue?: string,
    tooltip?: string
}

export const FatigueAssessmentQuestions = {
    hoursSleep24Hrs: {
        key: 'hoursSleep24Hrs',
        value: '1. How many hours of sleep have you had in the last 24 hours?'
    },
    hoursSleep48Hrs: {
        key: 'hoursSleep48Hrs',
        value: '2. How many hours of sleep have you had in the last 48 hours?'
    },
    currentHoursAwake: {
        key: 'currentHoursAwake',
        value: '3. How many hours have you been awake (or how long will you be awake by the end of your shift)?'
    },
    feelAlert: {
        key: 'feelAlert',
        value: '4. Do you feel alert?'
    },
    alcoholicDrinks: {
        key: 'alcoholicDrinks',
        value: '5. How many standard alcoholic drinks did you consume during the 12 hours prior to your last sleep?'
    },
    gender: {
        key: 'gender',
        value: '6. What is your sex?',
        altValue: 'Sex'
    },
    unfitSubstanceCheck: {
        key: 'unfitSubstanceCheck',
        value: '7. Are you on any medication or other substances that could cause drowsiness or cause you to be unfit for work?'
    },
    concentrationCheck: {
        key: 'concentrationCheck',
        value: '8. Do you have any stress, health problems or other personal problems that are significantly affecting your concentration and/or sleep impacting on your ability to complete your shift?'
    },
    user: {
        key: 'user.fullname',
        value: 'User'
    },
    supervisor: {
        key: 'supervisor.fullname',
        value: 'Shift supervisor'
    },
    signOnLocation: {
        key: 'signOnLocation.name',
        value: 'Sign-on location'
    },
    signOnLocationId: {
        key: 'signOnLocationId',
        value: 'Sign-on location',
        tooltip: 'Select your shift start Depot location'
    },
    shiftStartTime: {
        key: 'shiftStartTime',
        value: 'Shift start time'
    },
    assessmentDate: {
        key: 'assessmentDate',
        value: 'Assessment completed time'
    },
    risk: {
        key: 'risk',
        value: 'Risk rating'
    },
    onBehalfUser: {
        key: 'user',
        value: 'User',
        tooltip: 'Who are you submitting the on-behalf form for?'
    },
    shiftSupervisor: {
        key: 'supervisor',
        value: 'Shift supervisor',
        tooltip: 'Select your Shift Supervisor currently on shift TODAY'
    },
    shiftSupervisorId: {
        key: 'supervisorId',
        value: 'Shift supervisor',
        tooltip: 'Select your Shift Supervisor currently on shift TODAY'
    },
    partialShiftStartDate: {
        key: 'partialShiftStartDate',
        value: 'Shift start date'
    },
    partialShiftStartTime: {
        key: 'partialShiftStartTime',
        value: 'Shift start time'
    },
    onBehalfSubmitter: {
        key: 'onBehalfSubmitter.fullname',
        value: 'Fatigue Assessment On-behalf form completed by'
    },
    onBehalfReason: {
        key: 'onBehalfReason',
        value: 'Reason for submitting on-behalf'
    },
    controlsImplementedBy: {
        key: 'action.controlsImplementedBy.fullname',
        value: 'Controls implemented by',
        tooltip: 'Select the supervisor that applied the controls'
    },
    actionTakenGroup: {
        key: 'action',
        value: 'Action taken'
    },
    actionComment: {
        key: 'action.comment',
        value: 'Comments'
    },
    actionConfidential: {
        key: 'action.confidential',
        value: 'Mark as confidential',
        tooltip: 'Will this FA contain confidential comments?'
    },
    actionSupervisors: {
        key: 'action.affectedSupervisors',
        value: 'Affected supervisors',
        tooltip: 'Which supervisors will be able to view this FA, even if it\'s confidential'
    },
    actionSupervisorSignature: {
        key: 'action.supervisorSignature',
        value: 'Supervisor signature'
    },
    actionAlternativeSupervisorReason: {
        key: 'action.alternativeSupervisorReason',
        value: 'Alternative supervisor reason'
    },
    privacyPolicy: {
        key: 'privacyPolicy',
        value: 'Please read and indicate your acceptance of the following declaration. <br> I consent to BHP collecting, using and processing my personal information to manage BHP’s safe working environment.  Please see BHP’s <a href="https://www.bhp.com/privacy-policy" target="_blank">Privacy Policy</a> and <a href="https://spo.bhpbilliton.com/sites/DW/Pages/Privacy.aspx?CT=1665059601799&amp;OR=OWA-NT&amp;CID=3d371a96-67a5-e5b5-b5a8-aa583bef38ec" target="_blank">Global Privacy Notice </a> for BHP’s Workers for more detail about how we manage personal information.',
    }
}

export default FatigueAssessmentQuestions;
